export const HAKLAI_PRE_CALC_LABELS = Object.freeze({
  purchase: "רכישה",
  inheritance: "ירושה",
  gift: "מתנה מקרוב",
  singleApartment: "דירה יחידה",
  yes: "כן",
  no: "לא",
  basicInfoTitle: "פרטים בסיסיים למכירת נחלה",
  acquisitionDetailsTitle: "פרטי רכישה",
  soldDate: "מועד מכירה",
  saleValue: "שווי המכירה",
  hasZaban: 'האם קיימות זב"ן במשק?',
  wayOfGettingProperty: "אופן קבלת הנכס",
  purchaseDate: "תאריך הרכישה",
  purchaseAmountOriginalCurrency: "סכום הרכישה במטבע המקורי",
  testatorPassingDate: "תאריך פטירת המוריש",
  testatorPurchaseDate: "תאריך הרכישה של המוריש",
  testatorPurchaseAmountOriginalCurrency: "סכום הרכישה של המוריש במטבע המקורי",
  testatorPassingValueOriginalCurrency: 'שווי הרכישה ביום פטירת המוריש, במטבע המקורי, עפי דו"ח העזבון',
  testator: "המוריש",
  giftDonorPurchaseDate: "תאריך הרכישה של נותן המתנה",
  giftDonorPurchaseAmountOriginalCurrency: "סכום הרכישה של נותן המתנה במטבע המקורי",
  giftDonor: "נותן המתנה",
  costBy: "\u05E2\u05F4\u05D9",
  partialAcquisitionCost: "עלות הרכישה חלק יחסי",
  hasPtor: "האם קיימת לך זכאות לאחד הפטורים?",
  hasTzinunOnPtor: "האם קיימת לך מגבלת צינון?",
  checkTzinunEligibility: "לבדיקת תקופת הצינון לחץ כאן",
  rabinovichEligibilityQuestion: "האם המוכר זכאי להנחה במס שבח, בגין רכישה שבוצעה בתקופה הקובעת, לפי סעיף 48א(ד1)?",
  checkEligibility: "בדוק זכאות"
});

export const HAKLAI_PRE_CALC_MESSAGES = Object.freeze({
  usdRateLoading: "טוען שער לתאריך שנבחר...",
  usdRateMissing: "לא נמצא שער לתאריך שנבחר",
  propertyPartsPrerequisite: "יש להשלים את פרטי העסקה והרכישה לפני מעבר למרכיבי הנכס",
  expensesPreCalcPrerequisite: "יש להשלים את פרטי העסקה והרכישה לפני הזנת ניכויים",
  expensesPropertyPartsPrerequisite: "יש להשלים את מרכיבי הנכס לפני הזנת ניכויים"
});

export const HAKLAI_PRE_CALC_ERRORS = Object.freeze({
  invalidParcel: "נכס לא תקף",
  addressNotFound: "לא נמצא—בדקו כתובת",
  addressSearchFailed: "חיפוש נכשל—נסו שוב או גוש/חלקה",
  soldDateInvalid: "מועד לא תקין",
  soldDateFuture: "מועד עתידי",
  saleValueRequired: "יש להזין שווי מכירה",
  wayOfGettingPropertyRequired: "יש לבחור אופן קבלת הנכס",
  acquisitionDateInvalid: "תאריך לא תקין",
  acquisitionDateFuture: "תאריך עתידי",
  acquisitionDateAfterSale: "אחרי מועד המכירה",
  testatorPassingDateInvalid: "תאריך לא תקין",
  testatorPassingDateFuture: "תאריך עתידי",
  testatorPassingDateAfterSale: "אחרי מועד המכירה",
  testatorPurchaseDateRequired: "חסר תאריך",
  testatorPurchaseDateFuture: "תאריך עתידי",
  testatorPurchaseDateAfterSale: "אחרי מועד המכירה",
  testatorPurchaseDateAfterPassing: "אחרי הפטירה",
  purchaseAmountRequired: "יש להזין את סכום הרכישה",
  genericDateInvalid: "תאריך לא תקין"
});

export const HAKLAI_TZINUN_DIALOG_LABELS = Object.freeze({
  title: "בדיקת מגבלת צינון לשימוש בפטור דירה יחידה 49ב'(2) עבור דירה יחידה שהתקבלה במתנה",
  giftedFromRelatedQuestion: "האם הדירה או חלק ממנה התקבלה כאמור לעיל במתנה?",
  giftedDateQuestion: "מתי התקבלה הדירה במתנה?",
  recipientBirthDateQuestion: "מה תאריך הלידה של מקבל המתנה (עבור בני זוג - עפ\"י המבוגר שבהם)?",
  recipientLivesInPropertyQuestion: "האם מקבל המתנה מתגורר בדירה?",
  systemDecision: "החלטת המערכת:",
  coolingLimitExists: "קיימת מגבלת צינון",
  noCoolingLimit: "אין מגבלת צינון"
});

export const HAKLAI_TZINUN_DIALOG_ERRORS = Object.freeze({
  missingSoldDate: "יש להזין מועד מכירה לפני בדיקת תקופת הצינון",
  giftedDateFuture: "תאריך קבלת המתנה לא יכול להיות תאריך עתידי",
  birthDateFuture: "תאריך הלידה לא יכול להיות תאריך עתידי",
  giftedDateAfterSale: "תאריך קבלת המתנה לא יכול להיות לאחר תאריך המכירה",
  birthDateAfterSale: "תאריך הלידה לא יכול להיות לאחר תאריך המכירה"
});

export const getHaklaiSoldDateBeforeEarliestError = (date) => (
  `לפני ${date}`
);

export const getHaklaiSelectedDateRateMessage = (amountLabel, usdRateLabel) => (
  `לתאריך שנבחר: ${amountLabel} (שער ${usdRateLabel})`
);

export const getHaklaiShekelCalculationMessage = (amountLabel) => (
  `לחישוב בש"ח: ${amountLabel}`
);

export const getHaklaiSeededCostByLabel = (sourceLabel) => (
  `עלות רכישה ${HAKLAI_PRE_CALC_LABELS.costBy} ${sourceLabel}`
);

export const getHaklaiTzinunLimitResultText = ({ isChecked, hasTzinunOnPtor }) => (
  `מגבלת צינון: ${
    isChecked
      ? (hasTzinunOnPtor
          ? HAKLAI_TZINUN_DIALOG_LABELS.coolingLimitExists
          : HAKLAI_TZINUN_DIALOG_LABELS.noCoolingLimit)
      : ""
  }`
);

export const getHaklaiTzinunStartDateResultText = (dateLabel) => (
  `תאריך תחילת תקופת הצינון: ${dateLabel}`
);

export const getHaklaiTzinunEndDateResultText = (dateLabel) => (
  `תאריך סיום תקופת הצינון: ${dateLabel}`
);
